module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "titleH"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/2#ithanks",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Thanks")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/2#letter",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Letter to Readers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" one "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("S")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMPLE")]), _c('span', [_vm._v(" P")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEASURES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Miracles ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Walt Whitman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Holy Tomatoes ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Ginny Lowe Connors")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Surprised ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Maryanne Hannan")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Morning ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Michael S. Glaser")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Simple Pleasures ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Susanne Wiggins Bunch")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Gentle Things ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Thomas L. Reid")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Sunday Afternoon at Munsinger Gardens ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Leah Browning")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Happiness ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Crooker")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#cha1_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Gifts ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Clay Harrison")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("two ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("E")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERYDAY")]), _c('span', [_vm._v(" L")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])])]), _c('span', {
    staticClass: "small"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("No Need to Worry ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Author unknown")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("A Bit of Joy ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Betty Ann Leavitt")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Wash Prayer ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Lisa Zimmerman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Early Morning Gratitude Check ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Younger")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Let the Day Break S")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("andra H. Bounds")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("This Ordinary World ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Sherri Waas Shunfenthal")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("This Body ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Janine Canan")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Both Ways ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Cindy Breedlove")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#cha2_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Morning Light ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Schmitz")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("three ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _c('span', [_vm._v(" N")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURAL")]), _c('span', [_vm._v(" W")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Third Beatitude ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Susan J. Erickson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("April, by the Little Jordan ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Crooker")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Instructions ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Deborah Gordon Cooper")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("No Other Joy ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Francis Jammes, translated by Janine Canan")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("May Day, Betpouey, the Pyranees ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Michael S. Glaser")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("On Guardian Angels ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Richard Beban")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Wilding ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("C. David Hay")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("On Reading Genesis ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Dorothy Winslow Wright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("With One Voice, Rising ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Mary Harwell Sayler")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Magic ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Sudie Nostrand")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#cha3_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Blessings of the Rain ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Tirzi Heidingsfeld")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("four ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("F")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIENDS")]), _c('span', [_vm._v(" & F")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Celebration ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Lori Eberhardy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Open Hearts ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Dianne M. Del Giorno")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("With the Children ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Michael D. Heilman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Between You and Me ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Lori Eberhardy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Power of Grace ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("DeMar Regier")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Friendship ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Dinah Maria Mulock Craik")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Walking with Dog ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Gary E. McCormick")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("An Angel in Disguise ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Mary Maude Daniels")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Midnight Feedings ")]), _vm._v(" "), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Nancy Tupper Ling")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("A Bedtime Prayer ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Jennifer Lynn Clay")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("At Midafternoon ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Magie Dominic")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Fortunate ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Lori Eberhardy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#cha4_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("One at a Time ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("George Perreault")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("five ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("J")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("OY")]), _c('span', [_vm._v(" & W")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDER ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Joy ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Zoraida Rivera Morales")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Soul at Dawn ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rumi, translated by Coleman Barks")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("For All These I Am Grateful ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Ruth Fogelman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Thankful ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Marilyn Johnston")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Joy’s Abundance ")]), _vm._v(" "), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Leslie Neilson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("How Should We Rise ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Arlene Gay Levine")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Nature’s Goodness ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Charmaine Pappas Donovan")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cha5_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Praise Life! ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rabbi Rami Shapiro")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("six ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("F")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _c('span', [_vm._v(" & C")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Be Still in the World ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Charles Ghigna")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Your Faithfulness ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Anne Calodich Fone")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("At the Sacred Cliffs of Kauai ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Christine Swanberg")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("For We Are Here, ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Crooker")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Living in the Present ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Henry David Thoreau")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Breathing In ")]), _vm._v(" "), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Nancy Lynch Gibson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Whispers ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Gwen Tremain Runyard")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Dancing Toward the Source ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Joanne Seltzer")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Always a Glimmer of Hope ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Albert Schweitzer")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("A Joyful Day ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Hilda Lachney Sanderson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("A Conquest ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Lucy Larcom")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cha6_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Most Richly Blessed ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Author unknown")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("seven ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("P")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYERS")]), _c('span', [_vm._v(" & B")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Gratitude Toast ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Mary Maude Daniels")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Dear God ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Joanne Seltzer")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Thanks upon Awakening ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Paula E. Kirman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Miracle ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Theresa Mary Grass")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Gratitude Before Sleep ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Paula E. Kirman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Blessings of the Day ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Sally Clark")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("This Day and Always ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Kay Elizabeth")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Family Prayer ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Robert Louis Stevenson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("If I Could ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Gayle Brandeis")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Toast to the Now ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Susan J. Erickson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Our Ride Among the Stars ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Shirley Kobar")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cha7_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("On This Day’s Road ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Jim Croegaert")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("eight ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("R")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Offer ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Sara Sanderson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("This Step ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Deborah Gordon Cooper")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("What You Focus on Expands ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Val Heart")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("April Slips on Her Green Silk Dress, ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Crooker")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("This ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Sheila O’Connor")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Have a Nice Day ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Carol Oyanagi")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Good Portion ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Paul Willis")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("A Poem of Delight ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Dan Vera")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Peony ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Crooker")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("How Fortunate ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Linda Goodman Robiner")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Country Lane ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("C. David Hay")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Stop and Smell the Roses ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rhonda Hull")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("There Is a Worship ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Cassie Premo Steele")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Blessings and Skills of Others ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Dale Turner")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cha8_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Before It Is Too Late ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Frank Herbert Sweet")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("nine ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_c('span', [_vm._v("I")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSPIRATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Music ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Corrine De Winter")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Together ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Arlene Gay Levine")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Gift ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Joan Stephen")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Weather Report ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("BJ Gallagher")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Love Is God’s Creation ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Fyodor Dostoyevsky")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("It Is the Grateful Heart ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Karen O’Leary")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Living Out Loud ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Lori Eberhardy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Counting Blessings ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Barbara Younger")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Light Into the World ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Carol Merolla")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Give Thanks ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Chief Tecumseh")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Beauty ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Helen Bar-Lev")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("For as Long as It Matters ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Dorothy Wilhelm")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("Grateful to Be Grateful ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Carmela Tal Baron")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("The Road ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Arlene Gay Levine")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cha9_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', [_vm._v("This Is It #2 ")]), _c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("James Broughton")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Header"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("ten ")]), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.png"
    }
  }), _c('span', {
    staticClass: "char-style-override-17"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color3"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RATITUDE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOSTERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "0.5em"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SHORT INSPIRATIONAL THOUGHTS ")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Gotthold Ephraim Lessing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Pierre Teilhard de Chardin")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rabindranath Tagore")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Robert Brault")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Cynthia Ozick")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Denis Waitley")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("G. Richard Rieger")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Jean-Baptiste Alphonse Karr")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rudyard Kipling")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Anne Frank")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Ralph Waldo Emerson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Thornton Wilder")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Sam Lefkowitz")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Martha Washington")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Emily Dickinson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rabbi Abraham Joshua Heschel")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Anne Sophie Swetchine")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Annie Dougherty")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Rebbe Nachman of Breslov")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Mary Lenore Quigley")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cha10_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_c('span', {
    staticClass: "Baskerville-Italic"
  }, [_vm._v("Ellen Vaughn")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_vm._v("Author Index  ")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_vm._v("Permissions and Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/about_the_author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "balck"
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b12612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 66
// module chunks = 0